import {useAppSelector} from '../../../helpers/reduxHelpers';
import {makeGetInitialFeatureFlagsSubset} from '../../../store/featureFlags/featureFlagsSelectors';
import {FeatureFlagsMap} from '../../../store/featureFlags/featureFlagsState';
import {FeatureFlagsEnum} from '../../../store/featureFlags/featureFlagsTypes';

/**
 * Only returns a subset of all feature flags used by expressions.
 */

const expressionFeatureFlags = [FeatureFlagsEnum.CIRCLES, FeatureFlagsEnum.TABLE_BASED_RULES] as const;
export type ExpressionFeatureFlagsType = typeof expressionFeatureFlags[number];

const getExpressionFeatureFlags = makeGetInitialFeatureFlagsSubset(expressionFeatureFlags);

export function useExpressionsFeatureFlags(): FeatureFlagsMap {
  return useAppSelector(getExpressionFeatureFlags);
}
